import React from 'react';

import classnames from 'classnames';

type BackIconProps = {
  className: string;
};

const BackIcon = ({ className }: BackIconProps) => (
  <svg className={classnames(className)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="30">
    <path d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
  </svg>
);

export default BackIcon;
